import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { MultioComponent } from 'src/app/generales/components/multio/multio.component';
import { DirectorioService } from 'src/app/generales/login/services/directorio.service';
import { BalanceService } from 'src/app/generales/services/balance.service';
import { LoadingService } from 'src/app/generales/services/loading.service';
import { ToastService } from 'src/app/generales/services/toast.service';
import { UiService } from '../../../../admin/service/ui.service';
import { ModalContactoVendedorComponent } from '../../../../generales/components/modal-contacto-vendedor/modal-contacto-vendedor.component';
import { AdminServiceService } from 'src/app/admin/service/admin-service.service';
import { StripeComponent } from 'src/app/admin/components/stripe/stripe.component';

@Component({
  selector: 'app-pasarela-pago',
  templateUrl: './pasarela-pago.component.html',
  styleUrls: ['./pasarela-pago.component.scss'],
})
export class PasarelaPagoComponent implements OnInit {
  @ViewChild('stripeComponent') stripeComponent: StripeComponent;
  @Input() list: any[];
  @Input() walletTransactionId: number = undefined;
  @Input() payment: number = undefined;
  @Input() numberWp: any;
  @Input() country: string;
  @Input() storeId: number;
  total: number = 0;
  currencyIcon = '/assets/img/icons/moneda.svg';
  compra: UntypedFormGroup;
  selectedWpp = undefined;
  arrWpp = undefined;
  createdBanks = undefined;
  selectedBank: any[] = [];
  dataBank = '';
  currency = undefined;
  voucherName = '';
  voucher: File = undefined;
  public pasarelas = [];
  public gatewayData: any = {
    type: '',
    data: {},
  };

  constructor(
    private modalCtrl: ModalController,
    private fb: UntypedFormBuilder,
    private uiSv: UiService,
    private directorioSv: DirectorioService,
    private loadingSv: LoadingService,
    private translateSv: TranslateService,
    private toastSv: ToastService,
    private balanceService: BalanceService,
    private adminSv: AdminServiceService
  ) {}

  async ngOnInit() {
    const params = {
      storeId: this.storeId,
    };

    const res: any = await this.adminSv.get('paymentGateway/index', '', params);
    const pasarelas = res.data.map((x) => {
      return {
        nameBank: `${x.type} - ${x.name}`,
        name: x.type.toLowerCase(),
        key: x.key,
        paymentGatewaysId: x.id,
      };
    });
    this.pasarelas = pasarelas;

    this.currency = await this.balanceService.setCurrency();
    this.balanceService.currency.subscribe((data) => {
      this.currency = data;
    });
    console.log('this.walletTransactionId :>> ', this.walletTransactionId);
    if (this.walletTransactionId) {
      console.log('this.payment :>> ', this.payment);
      this.total += this.payment;
    } else {
      this.list?.forEach((producto) => {
        for (let i = 0; i < producto.cantidad; i++) {
          this.total += producto.price;
        }
      });
    }
    await this.loadingSv.show();
    this.directorioSv.getBanks(this.storeId).subscribe(
      async (res: any) => {
        this.createdBanks = res.data;
        await this.loadingSv.hide();
      },
      async (err) => {
        await this.loadingSv.hide();
      }
    );

    this.compra = this.fb.group({
      name: [''],
      email: [''],
      phone: [''],
      direction: [''],
      returnOfMoney: [false],
      amountReturnOfMoney: [{ value: '', disabled: true }],
      type: [''],
      detail: [''],
      ref: [''],
      bank: [''],
      branch: [''],
      date: [''],
      paymentGatewaysId: [''],
    });

    this.compra.get('returnOfMoney').valueChanges.subscribe((res) => {
      console.log(res);
      if (res) {
        this.compra.get('amountReturnOfMoney').enable();
      } else {
        this.compra.get('amountReturnOfMoney').disable();
      }
    });
    // console.log(this.numberWp);

    if (
      this.numberWp &&
      typeof this.numberWp === 'object' &&
      this.numberWp.length
    )
      this.arrWpp = this.numberWp;
    else this.selectedWpp = this.numberWp;
  }

  setTypeGateway(ev) {
    const id = ev.detail.value;
    this.gatewayData.data = this.pasarelas.find(
      (x) => x.paymentGatewaysId === id
    );
    if (this.gatewayData.data)
      this.gatewayData.type = this.gatewayData.data.name;
    else {
      this.gatewayData.type = '';
      this.gatewayData.data = {};
    }
  }

  setTransaction(transactionId, data) {
    data.reference = transactionId;
    // this.pay();
  }

  async OpenMulticurrency(ev) {
    await this.uiSv.createPop(
      MultioComponent,
      { currency: true },
      'popMulti',
      ev
    );
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  changeNum(event) {
    const value = (<HTMLIonSelectElement>event.detail).value;
    const branck = this.numberWp.find((x) => x.name === value);
    this.selectedWpp = `${branck.code}${branck.url}`;
  }

  setVoucher(ev) {
    const file = ev.target.files[0];
    this.voucherName = file.name;
    this.voucher = file;
  }

  setBank(event) {
    this.dataBank = 'Transacción a: %0A';
    this.selectedBank = [];
    const name = event.detail.value;
    const bank = this.createdBanks.find((x) => x.nameBank === name);
    for (let key of Object.keys(bank)) {
      if (key !== 'id' && key !== 'store_id' && key !== 'currencyId') {
        let keyData = this.translateSv.instant(
          `SENTENSES.${key.toUpperCase()}`
        );
        const obj = {
          key: keyData,
          value: bank[key],
        };
        if (obj.value) {
          this.dataBank += `${obj.key}: ${obj.value} %0A`;
          this.selectedBank.push(obj);
        }
      }
    }
  }

  async copyAccount(account) {
    window.navigator.clipboard.writeText(account);
    await this.toastSv.show('Copiado al portapapeles');
  }

  async continue() {
    const formData = new FormData();
    let datosUsuario = '';
    let cart = '';
    if (this.walletTransactionId) {
      formData.set('walletTransactionId', this.walletTransactionId.toString());
    }
    this.list?.forEach((producto) => {
      if (producto.isChecked) {
        cart += `Nombre Producto: ${producto.title} Cantidad: (${producto.cantidad})%0A`;
      }
    });

    for (const key of Object.keys(this.compra.value)) {
      if (
        this.compra.value[key] &&
        key !== 'returnOfMoney' &&
        key !== 'phone'
      ) {
        let fixedKey = '';
        if (key === 'name') {
          fixedKey = 'Nombre';
        } else if (key === 'email') {
          fixedKey = 'Email';
        } else if (key === 'direction') {
          fixedKey = 'Dirección';
        } else if (key === 'amountReturnOfMoney') {
          fixedKey = 'Monto de vueltos';
        } else if (key === 'type') {
          fixedKey = 'Tipo';
        } else if (key === 'detail') {
          fixedKey = 'Detalle';
        } else if (key === 'ref') {
          fixedKey = 'Referencia';
        } else if (key === 'bank') {
          fixedKey = 'Banco';
        } else if (key === 'branch') {
          fixedKey = 'Sucursal';
        } else if (key === 'date') {
          fixedKey = 'Fecha';
        } else if (key === 'branch') {
          fixedKey = 'Sucursal';
        }
        if (this.compra.value[key]) {
          formData.set(key, this.compra.value[key]);
          datosUsuario += `${fixedKey}: ${this.compra.value[key]}%0A`;
        }
      }
    }

    formData.set('totalPrice', this.total.toString());
    if (this.voucher) formData.set('file', this.voucher);
    if (this.list) formData.set('products', JSON.stringify(this.list));
    if (this.storeId) formData.set('storeId', this.storeId.toString());

    if (this.gatewayData.type === 'stripe') {
      const token: string = await this.stripeComponent.createSource();
      formData.set('token', token);
    } else if (this.gatewayData.type === 'paypal') {
      formData.set('ref', this.gatewayData.data.reference);
    }

    await this.directorioSv.postOrder(formData);

    let numberWp = this.selectedWpp || this.numberWp;
    if (typeof this.numberWp === 'object') {
      numberWp = this.numberWp.map((x) => `${x.code}${x.url}`)[0];
    }
    const data =
      (datosUsuario += `%0A${cart} %0A${this.dataBank} %0ATotal: $${this.total}`);
    const modal = await this.uiSv.createModal(
      ModalContactoVendedorComponent,
      {
        creatingStore: true,
        message: `Tu ${
          this.walletTransactionId ? 'recarga' : 'pedido'
        } ha sido enviado!`,
        buttonsCreateStore: [{ business_name: 'Listo' }],
        buying: true,
        numberWp,
        data,
      },
      'custom-modal'
    );
    let url = undefined;
    if (numberWp?.includes('https')) {
      url = `${numberWp}&text=Pedido hecho desde tu tienda On Line en Amarillas App %0A${data}`;
    } else {
      url = `https://api.whatsapp.com/send?phone=${numberWp}&text=Pedido hecho desde tu tienda On Line en Amarillas App %0A${data}`;
    }
    if (modal && !this.walletTransactionId) {
      window.open(url, '_blank');
      setTimeout(async () => {
        await this.modalCtrl.dismiss('buyed');
      }, 500);
    }
  }
}
